import React from "react";
import Profile from "../Components/Profile/Profile";

function UserProfile() {
  return (
    <div>
      <div className="px-10 py-7">
        <Profile />
      </div>
    </div>
  );
}

export default UserProfile;
